module.exports = "https://health.dajiuxing.com.cn/img/assets/rightsDetails/chronicDisease/fwqybtleft.png"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=assets%2FrightsDetails%2FchronicDisease%2Ffwqybtleft.png
// module id = TSjh
// module chunks = 93